import { useEffect, useState } from 'react'

import { useAppDispatch } from 'store'
import { EventActions } from 'store/pages/event'
import { LocationActions } from 'store/pages/location'
import { getBulkEventIdsKey } from 'helpers/event/ids'

import { useBulkEventsLocationIds } from 'hooks/useEvent'

interface Props {
  eventIds: number[] | string[]
  skipLocation?: boolean
}

const useBulkWalletEventData = (props: Props) => {
  const { eventIds, skipLocation } = props

  const dispatch = useAppDispatch()

  const eventIdsKey = getBulkEventIdsKey(eventIds)

  const locationIds = useBulkEventsLocationIds({ eventIdsKey })

  const [eventsFetchedAlready, setEventsFetchedAlready] = useState<boolean>(false)
  const [locationsFetchedAlready, setLocationsFetchedAlready] = useState<boolean>(false)

  useEffect(() => {
    if (!eventsFetchedAlready) {
      dispatch(EventActions.getBulkData({ idsOrCodeUrls: eventIds.map((x) => String(x)) }))
      setEventsFetchedAlready(true)
    }
  }, [eventIds])

  useEffect(() => {
    if (locationIds) {
      const uniqueLocationIds = [...new Set(locationIds)]

      if (uniqueLocationIds && !locationsFetchedAlready && !skipLocation) {
        dispatch(LocationActions.getBulkData({ idsOrCodeUrls: uniqueLocationIds.map((x) => String(x)) }))
        setLocationsFetchedAlready(true)
      }
    }
  }, [locationIds])
}

export default useBulkWalletEventData
